import { UserListIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Author = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <UserListIcon {...rest} size={Sizes[size]} color={fill} />;
};

Author.displayName = 'Author';
